










































import { defineComponent, PropType, useFetch, computed } from '@nuxtjs/composition-api';
import TopGourmetSnackCard from '~/components/pages/Top/TopGourmetSnackCard.vue';
import TopHorizontalItems from '~/components/pages/Top/TopHorizontalItems.vue';
import TopSection from '~/components/pages/Top/TopSection.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useStore } from '~/composables/useStore';
import { PRODUCT_PARENT_CATEGORY_ID, PRODUCT_PARAM_QUERIES } from '~/constants';
import { url } from '~/utils';
import { TopGourmetSnack } from '~/types/modules/top';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    TopSection,
    TopHorizontalItems,
    TopGourmetSnackCard,
    AppLink,
  },
  props: {
    items: {
      type: Array as PropType<TopGourmetSnack[]>,
      default: null,
    },
  },
  setup() {
    const store = useStore();

    useFetch(async () => {
      await store.dispatch('product/master/fetchSnackCategories', {});
    });

    const snackCategories = computed(() => {
      return store.state.product.master.snackCategories;
    });

    return {
      url,
      PRODUCT_PARENT_CATEGORY_ID,
      PRODUCT_PARAM_QUERIES,
      BooleanLike,
      snackCategories,
    };
  },
});
